export const PromoActionsEnum = {
  GO_TO_DEPOSIT: 'deposit',
  TOURNAMENTS: 'tournaments',
  GAMES: 'games',
  PROMO_AUTH: 'promo-auth',
  GET_BONUS: 'get-bonus',
  GO_TO_BONUSES: 'bonuses',
  HUNT: 'hunt',
  HUNT_DEPOSIT: 'hunt-deposit',
} as const;

export type PromoActionsType = (typeof PromoActionsEnum)[keyof typeof PromoActionsEnum];
